import { handleApiError, phpApi } from "../../../../api";

export const initTask = (instanceId, taskId) => {
  return phpApi.post(
    `/api/content/${instanceId}/task/init`,
    { task: taskId },
  ).catch(handleApiError);
};

export const saveAnswers = (instanceId, taskAttemptId, taskId, answers) => {
  return phpApi.post(
    `/api/content/${instanceId}/task/${taskAttemptId}/save`,
    {
      answers,
      task: taskId,
    },
  ).catch(handleApiError);
};
